app.controller("EmployeeDraftDocumentsController", [
    "$scope", "$stateParams", "DocumentsService", "StaticData", "ConfirmModal", "$state", "toastr", "usSpinnerService", "$rootScope",
    function ($scope, $stateParams, DocumentsService, StaticData, ConfirmModal, $state, toastr, usSpinnerService, $rootScope) {
        $scope.documents = [];
        $scope.totalItems = 0;
        $scope.onlyOrganizationDrafts = $stateParams.onlyOrganizationDrafts || '';
        $scope.documentTypes = {
            'INNER': [],
            'STUDENT_INNER': [],
            'OUTER': [],
            'OUTGOING': []
        };
        $scope.format = "dd-MM-yyyy hh:mm:ss";

        StaticData.getItemsByKey("document_types").then(function (types) {
            $scope.documentTypesMap = _.keyBy(types, '_id');
        });

        function getDocumentTypes() {
            usSpinnerService.spin("root");
            DocumentsService.typeList({ admin: true }).then(function (data) {
                data.forEach(function (type) {
                    $scope.documentTypes[type.parentId].push(type)
                });

                usSpinnerService.stop("root");
            }).catch(function () {
                usSpinnerService.spin("root");
                toastr.error('', 'დაფიქსირდა შეცდომა');
            });
        }

        getDocumentTypes();

        $scope.applyFilter = function () {
            $state.go(".", {
                onlyOrganizationDrafts: $scope.onlyOrganizationDrafts
            });
        };

        $scope.loadPage = function () {
            usSpinnerService.spin("root");
            DocumentsService.sentList({
                state: 'draft',
                onlyOrganizationDrafts: $scope.onlyOrganizationDrafts
            }).then(function (res) {
                $scope.documents = res.data.docs;
                $scope.totalItems = res.data.total;
                usSpinnerService.stop("root");
            });
        };

        $scope.loadPage();

        $scope.open = function (doc, $event) {
            if ($event) {
                $event.stopPropagation();
            }
            $state.go('employee.documents.new', { documentId: doc._id })
        };

        $scope.select = function (documentId, $event) {
            if ($event) {
                $event.stopPropagation();
            }
        };

        $scope.download = function (url, $event) {
            if ($event) {
                $event.stopPropagation();
            }
            window.open(url);
        };

        $scope.edit = function (documentId, $event) {
            if ($event) {
                $event.stopPropagation();
            }
            $state.go('employee.documents.new', { documentId: documentId, action: 'edit' })
        };

        $scope.remove = function (documentId, $event) {
            if ($event) {
                $event.stopPropagation();
            }
            ConfirmModal.show({
                title: "შაბლონის წაშლა",
                message: "გსურთ შაბლონის წაშლა?"
            }).result.then(function () {
                usSpinnerService.spin("root");
                DocumentsService.removeDraft(documentId)
                    .then(function () {
                        usSpinnerService.stop("root");
                        $scope.loadPage();
                        $rootScope.documentsCount();
                        toastr.success('', 'შაბლონი წაშლილია');
                    });
            });
        };

        $scope.createDepartmentDocument = function () {
            $state.go('employee.documents.new', { department: '1' })
        }
    }
]);
